module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlBhdGggMyI+CjxnIGlkPSJ4Ij4KPHBhdGggaWQ9IlBhdGggNCIgZD0iTTIgMkwyMiAyMiIgc3Ryb2tlPSIjNjRDNENFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBpZD0iUGF0aCA0XzIiIGQ9Ik0yMiAyTDIgMjIiIHN0cm9rZT0iIzY0QzRDRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/cleardoc.svg
// module id = SKS/
// module chunks = 28